import { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

const Toast = ({ toast, onClose }) => {
  // Vérification de sécurité
  if (!toast || !toast.type) {
    return null;
  }

  useEffect(() => {
    if (toast.autoClose !== false) {
      const timer = setTimeout(() => {
        onClose();
      }, toast.duration || 5000);

      return () => clearTimeout(timer);
    }
  }, [toast, onClose]);

  const icons = {
    success: CheckCircle,
    error: XCircle,
    warning: AlertCircle,
    info: Info
  };

  const colors = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-orange-50 border-orange-200 text-orange-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800'
  };

  const iconColors = {
    success: 'text-green-600',
    error: 'text-red-600',
    warning: 'text-orange-600',
    info: 'text-blue-600'
  };

  const Icon = icons[toast.type] || Info;

  return (
    <div className={`fixed top-4 right-4 z-50 max-w-sm w-full shadow-lg rounded-lg border-2 p-4 animate-in slide-in-from-top-5 ${colors[toast.type] || colors.info}`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <Icon className={`h-5 w-5 ${iconColors[toast.type] || iconColors.info}`} />
        </div>
        <div className="ml-3 w-0 flex-1">
          {toast.title && (
            <p className="text-sm font-medium">{toast.title}</p>
          )}
          <p className={`text-sm ${toast.title ? 'mt-1' : ''}`}>
            {typeof toast.message === 'string' 
              ? toast.message 
              : toast.message?.message || toast.message?.code || String(toast.message || 'Erreur inconnue')}
          </p>
        </div>
        <div className="ml-4 flex-shrink-0 flex">
          <button
            onClick={onClose}
            className={`inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${
              toast.type === 'success' ? 'focus:ring-green-500' :
              toast.type === 'error' ? 'focus:ring-red-500' :
              toast.type === 'warning' ? 'focus:ring-orange-500' :
              'focus:ring-blue-500'
            } ${iconColors[toast.type] || iconColors.info} hover:opacity-75`}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Toast;






